export default __webpack_public_path__ + "static/O0210-d1bd290cf7922802921630807c6f270e.png";